"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Json = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 14,
  height: 12,
  viewBox: "0 0 14 12",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.631 7.116c-.317.206-.475.504-.475.894v2.12c0 .69-.233 1.175-.7 1.453-.396.24-1.048.379-1.956.415a.486.486 0 01-.5-.49v-.535c0-.271.217-.484.484-.533.225-.042.393-.112.503-.21.178-.156.267-.387.267-.692V7.466c0-.795.562-1.31 1.686-1.467-1.096-.153-1.658-.691-1.686-1.534V2.453c0-.305-.09-.536-.267-.693-.112-.097-.28-.166-.504-.209C9.217 1.501 9 1.29 9 1.018V.49c0-.276.224-.501.5-.49.908.035 1.56.174 1.957.414.466.278.699.76.699 1.447v2.193c0 .368.156.65.468.848.22.139.512.229.877.27.274.031.499.25.499.526v.608c0 .276-.225.495-.499.528-.36.043-.65.137-.87.282zM1.37 7.118c.317.206.475.504.475.894v2.12c0 .69.233 1.175.7 1.453.396.24 1.048.379 1.956.415.276.01.5-.215.5-.491v-.534c0-.271-.217-.483-.484-.533-.225-.043-.393-.112-.503-.21-.178-.156-.267-.387-.267-.692V7.468c0-.795-.562-1.31-1.685-1.467 1.095-.153 1.657-.691 1.685-1.534V2.455c0-.305.09-.536.267-.693.112-.097.28-.166.504-.209.266-.05.483-.262.483-.533V.492a.486.486 0 00-.5-.49c-.908.035-1.56.174-1.957.414-.466.278-.699.76-.699 1.447v2.193c0 .368-.156.65-.468.848-.22.139-.512.229-.877.27-.274.03-.499.25-.499.526v.608c0 .276.225.495.499.528.36.043.65.137.87.282z",
  fill: "#ACB3BE",
  className: "fill"
}));

var _default = Json;
exports.default = _default;